import React from "react";
import Icon from "@cayuse/shared-react.components.icon";
import Button from "@cayuse/shared-react.components.button";

import styles from "./styles.css";

const FileInputComponent = () => {
    return (
		<div className={`${styles.uploadArea}`}>
			<div>
				<label>Drop files here to upload</label>
			</div>
			<div>
			or
			</div>
			<div>
				<Button primary disabled className={styles.uploadButton}>
					<Icon name="upload"></Icon>Upload File
				</Button>
			</div>
		</div>
	);
};

FileInputComponent.information = {
    type: "upload",
    name: "Attachment",
};

FileInputComponent.extraSettings = {
	autoupload: true
};

export default FileInputComponent;
